import { forwardRef, type ButtonHTMLAttributes, type ReactNode } from "react";
import {
  buttonVariants,
  type ButtonVariantsProps,
} from "@/shared/ui/atelier/Button.variants";
import { cn } from "@/shared/utils/style.util";

type NativeButtonProps = Omit<ButtonHTMLAttributes<HTMLButtonElement>, "type">;

type ButtonProps = {
  loading?: boolean
  leftIcon?: ReactNode
  rightIcon?: ReactNode
  type?: "button" | "submit" | "reset"
} & NativeButtonProps & ButtonVariantsProps;

const Button = forwardRef<HTMLButtonElement, ButtonProps>(
  (
    {
      variant,
      size,
      loading = false,
      disabled,
      leftIcon,
      rightIcon,
      type = "button",
      className,
      children,
      ...props
    },
    ref,
  ) => {
    const isDisabled = disabled === true || loading;

    return (
      <button
        ref={ref}
        type={type}
        disabled={isDisabled}
        aria-busy={loading || undefined}
        className={cn(buttonVariants({ variant, size }), className)}
        {...props}
      >
        {leftIcon ? <span aria-hidden="true">{leftIcon}</span> : null}
        {children !== undefined && children !== null && children !== false
          ? <span>{children}</span>
          : null}
        {rightIcon ? <span aria-hidden="true">{rightIcon}</span> : null}
      </button>
    );
  },
);

Button.displayName = "Atelier.Button";

export { Button };
export type { ButtonProps };
